var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid benjamin-moore-container" },
    [
      _c("div", { staticClass: "wf-page-controls mt-4 mt-lg-0" }, [
        _c("div", { staticClass: "wf-page-controls-items" }, [
          _c(
            "div",
            {
              staticClass:
                "wf-page-control-item wf-page-control-item-current-refinements"
            },
            [_c("benjamin-current-filter")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "\n          wf-page-control-item wf-page-control-item-product-display-controls\n        "
            },
            [
              _c("div", { staticClass: "wf-product-display-controls" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "wf-product-display-control wf-product-display-control-filter"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "wf-side-collapse-button wf-side-collapse-button-open btn shadow",
                        attrs: { type: "button" },
                        on: { click: _vm.filterSideBar }
                      },
                      [
                        _c("span", { staticClass: "pr-3" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$resourceString[
                                "product.search.display.filter"
                              ]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass:
                            "png-icon png-icon-icons-glyph--k-sort-filter m-0"
                        })
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wf-product-category" }, [
        _c("div", { staticClass: "wf-product-category-sidebar-mobile" }, [
          _c(
            "div",
            {
              staticClass: "wf-side-collapse",
              attrs: { id: "filters-side-collapse" }
            },
            [
              _c(
                "div",
                { staticClass: "wf-side-collapse-header justify-content-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "wf-side-collapse-button wf-side-collapse-button-close btn",
                      attrs: { type: "button" },
                      on: { click: _vm.filterSideBar }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$resourceString["product.search.close.button"]
                          ) +
                          "\n            "
                      ),
                      _c("span", {
                        staticClass: "png-icon png-icon-icons-glyph--g-close",
                        attrs: { "aria-label": "close button" }
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "wf-side-collapse-body" }, [
                _c(
                  "div",
                  { staticClass: "wf-side-collapse-section" },
                  [_c("benjamin-current-filter")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "wf-side-collapse-section" },
                  [_c("side-filter")],
                  1
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wf-product-category-sidebar-desktop" },
          [_c("side-filter")],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wf-product-category-results" }, [
          _c(
            "section",
            { staticClass: "wf-product-category-results-section" },
            [
              _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("h2", { staticClass: "secondary-heading" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$resourceString["benjaminMoore.Title"]) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("benjamin-search-bar"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wf-product-category-results" },
                    [
                      _c("benjamin-search-result", {
                        attrs: { results: _vm.results }
                      }),
                      _vm._v(" "),
                      _vm.showLoadMore
                        ? _c("pc-load-more", {
                            attrs: { "load-more": _vm.onLoadMore }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.results.length === 0 && !_vm.isFetching
                        ? _c("p", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$resourceString["comon.noResults"]) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }